import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'

import constants from 'constants/index'

const styles = ({ selectedTab }) =>
  makeStyles(() => {
    const isColorCustomization =
      constants.cookies.banner.COLOR_CUSTOMIZATION_CARD_ID
    const isLogoCustomization =
      constants.cookies.banner.LOGO_CUSTOMIZATION_CARD_ID
    const isFontCustomization =
      constants.cookies.banner.FONT_CUSTOMIZATION_CARD_ID

    return {
      colorCustomizationContainer: {
        display: selectedTab === isColorCustomization ? 'flex' : 'none',
        height: '100%',
        flexDirection: 'row',
      },
      logoUploadContainer: {
        display: selectedTab === isLogoCustomization ? 'flex' : 'none',
        height: '100%',
        flexDirection: 'row',
      },
      fontCustomizationContainer: {
        display: selectedTab === isFontCustomization ? 'flex' : 'none',
        height: '100%',
        flexDirection: 'row',
      },
      bannerPreviewContainer: {
        display:
          selectedTab === isColorCustomization ||
          selectedTab === isFontCustomization
            ? 'block'
            : 'none',
        height: '100%',
      },
      logoPreviewContainer: {
        display: selectedTab === isLogoCustomization ? 'block' : 'none',
        height: '100%',
      },
    }
  })

styles.propTypes = {
  selectedTab: PropTypes.number.isRequired,
}

export default styles
